import { useCallback, useMemo } from 'react'
import useSearchBar from '../components/property-details/hooks/use-searchbar'
import { Location } from '../components/search-result-listing/header-section/types'

interface UseSearchbarStateProps {
    query: any
    location?: string
}

export default function useSearchbarState({ query, location = '' }: UseSearchbarStateProps) {
    const { searchbar, updateSearchbar } = useSearchBar({ query, location })

    /** LOCATION */
    const locationValue = useMemo(() => ({ regionId: null, search: searchbar.location }), [searchbar.location])

    const onLocationChange = useCallback((loc: Location) => updateSearchbar('location', loc.search), [updateSearchbar])

    /** DATES */
    const onArrivalDateChange = useCallback((date: Date | null) => updateSearchbar('arrival', date), [updateSearchbar])

    const onDepartureDateChange = useCallback(
        (date: Date | null) => updateSearchbar('departure', date),
        [updateSearchbar],
    )

    /** GUESTS */
    const onAdultsCountChange = useCallback((count: number) => updateSearchbar('adults', count), [updateSearchbar])

    const onChildrenCountChange = useCallback((count: number) => updateSearchbar('kids', count), [updateSearchbar])

    return {
        searchbar,
        locationValue,
        onLocationChange,
        onArrivalDateChange,
        onDepartureDateChange,
        onAdultsCountChange,
        onChildrenCountChange,
    }
}
